import React, { useEffect, useState } from "react";
import PageTitle from "../components/PageTitle";
import SingleContentSection from "../components/Content/SingleContentSection";
import "./TaxLawPage.css";
import { BlogEntryItem } from "../utils/types/BlogEntryItem";

const TaxLawPage: React.FC = () => {
    const [currentItemContent, setCurrentItemContent] = useState<string>("");
    const [currentItemTitle, setCurrentItemTitle] = useState<string>("");
    useEffect(() => {
        const data = localStorage.getItem("main-articles");
        if (data) {
            const items = JSON.parse(data) as BlogEntryItem[];
            const item = items.filter(i => (i.blog.category === "mainContent" && i.meta.url == "danove-pravo"))[0];
            setCurrentItemContent(item.blog.content);
            setCurrentItemTitle(item.blog.title);
        }
    })

    return (
        <div>
            <PageTitle pageName="" desc="" id="obcianske-pravo" />
            <SingleContentSection title={currentItemTitle} text={currentItemContent} itemUrl="danove-pravo"></SingleContentSection>
        </div>
    );
}

export default TaxLawPage;